<div
	class="flex flex-col fixed inset-0 ease-out z-offcanvas shadow-around border-l border-l-secondary-200 bg-primary-100 dark:bg-standard md:absolute md:left-[calc(100%-31.125rem)] md:w-124.5 md:py-8 py-4 {{
		styleClass()
	}}"
	[@slideInOut]="open() ? 'open' : 'closed'"
	data-cy="ui-offcanvas"
>
	<div class="flex justify-between py-0 px-4 md:px-8">
		<div class="flex items-center gap-2 pb-4">
			<ui-headline type="h3" [noPadding]="true">{{ header() }}</ui-headline>
			<ng-content select="[offcanvas-header]"></ng-content>
		</div>
		@if (showCloseButton()) {
			<ui-button
				type="link-dark"
				(buttonClicked)="close()"
				icon="x_cross"
				data-cy="ui-offcanvas-close-icon"
			></ui-button>
		}
	</div>

	<div class="grow max-h-full overflow-y-auto px-4 pt-0 pb-2 w-full md:grow-0 md:px-8">
		<ng-content></ng-content>
	</div>
	<div class="px-4 pt-4 w-full md:px-8">
		<div class="flex flex-col gap-2">
			<ng-content select="[offcanvas-button]"></ng-content>
		</div>
	</div>
</div>
<div
	class="absolute inset-0 z-offcanvas-backdrop"
	[ngClass]="{ hidden: !open() || !closeOnOutsideClick() }"
	(click)="close()"
	data-cy="ui-offcanvas-backdrop"
></div>
